import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { ISetupApiService } from '../setup.api.interface';


@Injectable()
export class SetupApiServiceStub implements ISetupApiService {
    constructor() {

    }

    getBox() {
        throw new Error('Method not implemented.');
    }
}
